<template>
    <div>
      <div class="h100-80 h-scroll">
        <ejs-grid :dataSource="measureCustomDatas"  ref="grid" :height="screenHeight" :allowExcelExport='true' :allowResizing='true' 
        :allowTextWrap="true" :textWrapSettings="wrapSettings" >
          <e-columns>
            <e-column field="customCounterTypeId" :headerText="$t('Pm.customCounterTypeId')" minWidth='8' width='20%' textAlign="Center"    >
          
            </e-column>
            <e-column field="customCounterTypeName" :headerText="$t('Pm.customCounterTypeName')" minWidth='8' width='20%' textAlign="Center"  ></e-column>
            <e-column field="counterTypeId" :headerText="$t('Pm.counterTypeId')" minWidth='8' width='20%' textAlign="Center" ></e-column>
            <e-column field="counterTypeName" :headerText="$t('Pm.counterTypeName')" minWidth='8' width='20%' textAlign="Center" ></e-column>
            <e-column field="createTime" :headerText="$t('Security.Role.createTime')" :format="dateFormat" minWidth='8' width='20%' textAlign="Center" clipMode="EllipsisWithTooltip" ></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
</template>



<script>
import { Resize} from "@syncfusion/ej2-vue-grids";

export default {
  name: 'ShowMeasureCustom',
   provide: {
      grid: [ Resize]
    },
  data() {
    return {
      measureCustomDatas: [],
      dateFormat: {
        type: 'date', format: 'yyyy/MM/dd HH:mm:ss'
      },
      editId: '',
      screenHeight: document.body.clientHeight - 240
    };
  },
  methods: {
    findCounter(neTypeId, customCounterTypeId) {
      const url = '/lte/pm/measureCustom/selectCounter';
      const params = { params: {
        neTypeId : neTypeId,
        customCounterTypeId: customCounterTypeId
      }};
      const That = this;
      this.axios.get(url, params).then(response => {
        const result = response.data;
        if(result !== undefined && result.length >0){
          result.forEach((v) => {
            let date = new Date();
            if (!!v.createTime) {
              date.setTime(v.createTime);
              v.createTime = date;
            }
          });
        }
        That.measureCustomDatas = result;
      });
    }
  }
}
</script>


